import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const DateInputComponent = ({ dateInput = {} }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);

  const isHovered = dateInput.id === hoveredDivision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const [backgroundImagelabelUrl, setlabelbackgroundImagelabelUrl] =
    useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = dateInput;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const labelconstructGradientString = () => {
    const {
      labelbackgroundGradientImage,
      labelgradientDirection,
      labelgradientShape,
      labelgradientPosition,
      labelstartColor,
      labelendColor,
      labelgradientAngle,
      labelpatternLength,
    } = dateInput;

    switch (labelbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${labelgradientDirection || "to right"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${labelgradientShape || "circle"} at ${
          labelgradientPosition || "center"
        }, ${labelstartColor || "#ff7e5f"}, ${labelendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${labelgradientAngle || "45"}deg, ${
          labelstartColor || "#606dbc"
        }, ${labelendColor || "#465298"} ${labelpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          labelgradientShape || "circle"
        } at ${labelgradientPosition || "center"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"} ${labelpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = dateInput;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = dateInput;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = dateInput;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (
        dateInput.backgroundImage &&
        dateInput.backgroundImage.startsWith("./")
      ) {
        const imageName = dateInput.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(dateInput.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [dateInput.backgroundImage, files]);

  useEffect(() => {
    const fetchlabelbackgroundImagelabel = async () => {
      if (
        dateInput.labelbackgroundImagelabel &&
        dateInput.labelbackgroundImagelabel.startsWith("./")
      ) {
        const imageName = dateInput.labelbackgroundImagelabel.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setlabelbackgroundImagelabelUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setlabelbackgroundImagelabelUrl(dateInput.labelbackgroundImagelabel);
      }
    };

    fetchlabelbackgroundImagelabel();
  }, [dateInput.labelbackgroundImagelabel, files]);

  const focusedStyles =
    isDivFocused && dateInput.pseudoClass === "focus"
      ? {
          width: dateInput.focusedwidth || dateInput.width || "200px",
          height: dateInput.focusedheight || dateInput.height || "auto",

          padding: dateInput.focusedpadding || dateInput.padding || "0",
          paddingTop:
            dateInput.focusedpaddingTop || dateInput.focusedpadding || "0",
          paddingRight:
            dateInput.focusedpaddingRight || dateInput.focusedpadding || "0",
          paddingBottom:
            dateInput.focusedpaddingBottom || dateInput.focusedpadding || "0",
          paddingLeft:
            dateInput.focusedpaddingLeft || dateInput.focusedpadding || "0",
          margin: dateInput.focusedmargin || dateInput.margin || "0px",
          marginTop:
            dateInput.focusedmarginTop || dateInput.focusedmargin || "0px",
          marginRight:
            dateInput.focusedmarginRight || dateInput.focusedmargin || "0px",
          marginBottom:
            dateInput.focusedmarginBottom || dateInput.focusedmargin || "0px",
          marginLeft:
            dateInput.focusedmarginLeft || dateInput.focusedmargin || "10px",

          borderTop:
            dateInput.focusedborderTop ||
            dateInput.focusedborder ||
            dateInput.border ||
            "1px solid #000000",
          borderRight:
            dateInput.focusedborderRight ||
            dateInput.focusedborder ||
            dateInput.border ||
            "1px solid #000000",
          borderBottom:
            dateInput.focusedborderBottom ||
            dateInput.focusedborder ||
            dateInput.border ||
            "1px solid #000000",
          borderLeft:
            dateInput.focusedborderLeft ||
            dateInput.focusedborder ||
            dateInput.border ||
            "1px solid #000000",
          borderSapcing:
            dateInput.focusedborderSpacing || dateInput.borderSpacing || "0px",
          borderCollapse:
            dateInput.focusedborderCollapse ||
            dateInput.borderCollapse ||
            "0px",
          borderRadius:
            dateInput.focusedborderRadius || dateInput.borderRadius || "0",
          outline: dateInput.focusedoutline || dateInput.outline || "none",

          position:
            dateInput.focusedposition || dateInput.position || "relative",
          top: dateInput.focusedtop || dateInput.top || "auto",
          right: dateInput.focusedright || dateInput.right || "auto",
          bottom: dateInput.focusedbottom || dateInput.bottom || "auto",
          left: dateInput.focusedleft || dateInput.left || "auto",
          zIndex: dateInput.focusedzIndex || dateInput.zIndex || "auto",

          color: dateInput.focusedcolor || dateInput.color || "#000000",
          backgroundColor:
            dateInput.focusedbackgroundColor ||
            dateInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (dateInput.focusedbackgroundImage) {
              if (dateInput.focusedbackgroundImage.startsWith("./")) {
                const imageName = dateInput.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dateInput.focusedbackgroundImage})`;
            }
            if (dateInput.backgroundImage) {
              if (dateInput.backgroundImage.startsWith("./")) {
                const imageName = dateInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dateInput.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            dateInput.focusedbackgroundPosition ||
            dateInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            dateInput.focusedbackgroundSize ||
            dateInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            dateInput.focusedbackgroundRepeat ||
            dateInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            dateInput.focusedbackgroundAttachment ||
            dateInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            dateInput.focusedboxShadow || dateInput.boxShadow || "none",
          opacity: dateInput.focusedOpacity || dateInput.opacity || 1,
          display: dateInput.focuseddisplay || dateInput.display || "inline",

          fontFamily:
            dateInput.focusedfontFamily || dateInput.fontFamily || "inherit",
          fontSize:
            dateInput.focusedfontSize || dateInput.fontSize || "inherit",
          fontWeight:
            dateInput.focusedfontWeight || dateInput.fontWeight || "normal",
          fontStyle:
            dateInput.focusedfontStyle || dateInput.fontStyle || "normal",
          fontVariant:
            dateInput.focusedfontVariant || dateInput.fontVariant || "normal",
          lineHeight:
            dateInput.focusedlineHeight || dateInput.lineHeight || "normal",
          textShadow:
            dateInput.focusedtextShadow || dateInput.textShadow || "none",
          textAlign:
            dateInput.focusedtextAlign || dateInput.textAlign || "left",
          verticalAlign:
            dateInput.focusedverticalAlign ||
            dateInput.verticalAlign ||
            "baseline",
          textDecoration:
            dateInput.focusedtextDecoration ||
            dateInput.textDecoration ||
            "none",
          textTransform:
            dateInput.focusedtextTransform || dateInput.textTransform || "none",
          letterSpacing:
            dateInput.focusedletterSpacing ||
            dateInput.letterSpacing ||
            "normal",
          wordSpacing:
            dateInput.focusedwordSpacing || dateInput.wordSpacing || "normal",
          textIndent:
            dateInput.focusedtextIndent || dateInput.textIndent || "0",
          whiteSpace:
            dateInput.focusedwhiteSpace || dateInput.whiteSpace || "normal",
          textOverflow:
            dateInput.focusedtextOverflow || dateInput.textOverflow || "clip",
          direction: dateInput.focuseddirection || dateInput.direction || "ltr",
          unicodeBidi:
            dateInput.focusedunicodeBidi || dateInput.unicodeBidi || "normal",
          writingMode:
            dateInput.focusedwritingMode ||
            dateInput.writingMode ||
            "horizontal-tb",

          cursor: dateInput.focusedcursor || dateInput.cursor || "default",
          transform:
            dateInput.focusedtransform || dateInput.transform || "none",
          transition:
            dateInput.focusedtransition || dateInput.transition || "none",
        }
      : {};
  const hoverStyles =
    isDivHovered && dateInput.pseudoClass === "hover"
      ? {
          width: dateInput.hoveredwidth || dateInput.width || "200px",
          height: dateInput.hoveredheight || dateInput.height || "auto",

          padding: dateInput.hoveredpadding || dateInput.padding || "0",
          paddingTop:
            dateInput.hoveredpaddingTop || dateInput.hoveredpadding || "0",
          paddingRight:
            dateInput.hoveredpaddingRight || dateInput.hoveredpadding || "0",
          paddingBottom:
            dateInput.hoveredpaddingBottom || dateInput.hoveredpadding || "0",
          paddingLeft:
            dateInput.hoveredpaddingLeft || dateInput.hoveredpadding || "0",
          margin: dateInput.hoveredmargin || dateInput.margin || "0px",
          marginTop:
            dateInput.hoveredmarginTop || dateInput.hoveredmargin || "0px",
          marginRight:
            dateInput.hoveredmarginRight || dateInput.hoveredmargin || "0px",
          marginBottom:
            dateInput.hoveredmarginBottom || dateInput.hoveredmargin || "0px",
          marginLeft:
            dateInput.hoveredmarginLeft || dateInput.hoveredmargin || "10px",

          borderTop:
            dateInput.hoveredborderTop ||
            dateInput.hoveredborder ||
            dateInput.border ||
            "1px solid #000000",
          borderRight:
            dateInput.hoveredborderRight ||
            dateInput.hoveredborder ||
            dateInput.border ||
            "1px solid #000000",
          borderBottom:
            dateInput.hoveredborderBottom ||
            dateInput.hoveredborder ||
            dateInput.border ||
            "1px solid #000000",
          borderLeft:
            dateInput.hoveredborderLeft ||
            dateInput.hoveredborder ||
            dateInput.border ||
            "1px solid #000000",
          borderSapcing:
            dateInput.hoveredborderSpacing || dateInput.borderSpacing || "0px",
          borderCollapse:
            dateInput.hoveredborderCollapse ||
            dateInput.borderCollapse ||
            "0px",
          borderRadius:
            dateInput.hoveredborderRadius || dateInput.borderRadius || "0",
          outline: dateInput.hoveredoutline || dateInput.outline || "none",

          position:
            dateInput.hoveredposition || dateInput.position || "relative",
          top: dateInput.hoveredtop || dateInput.top || "auto",
          right: dateInput.hoveredright || dateInput.right || "auto",
          bottom: dateInput.hoveredbottom || dateInput.bottom || "auto",
          left: dateInput.hoveredleft || dateInput.left || "auto",
          zIndex: dateInput.hoveredzIndex || dateInput.zIndex || "auto",

          color: dateInput.hoveredcolor || dateInput.color || "#000000",
          backgroundColor:
            dateInput.hoveredbackgroundColor ||
            dateInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (dateInput.hoveredbackgroundImage) {
              if (dateInput.hoveredbackgroundImage.startsWith("./")) {
                const imageName = dateInput.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dateInput.hoveredbackgroundImage})`;
            }
            if (dateInput.backgroundImage) {
              if (dateInput.backgroundImage.startsWith("./")) {
                const imageName = dateInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dateInput.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            dateInput.hoveredbackgroundPosition ||
            dateInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            dateInput.hoveredbackgroundSize ||
            dateInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            dateInput.hoveredbackgroundRepeat ||
            dateInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            dateInput.hoveredbackgroundAttachment ||
            dateInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            dateInput.hoveredboxShadow || dateInput.boxShadow || "none",
          opacity: dateInput.hoveredOpacity || dateInput.opacity || 1,
          display: dateInput.hovereddisplay || dateInput.display || "inline",

          fontFamily:
            dateInput.hoveredfontFamily || dateInput.fontFamily || "inherit",
          fontSize:
            dateInput.hoveredfontSize || dateInput.fontSize || "inherit",
          fontWeight:
            dateInput.hoveredfontWeight || dateInput.fontWeight || "normal",
          fontStyle:
            dateInput.hoveredfontStyle || dateInput.fontStyle || "normal",
          fontVariant:
            dateInput.hoveredfontVariant || dateInput.fontVariant || "normal",
          lineHeight:
            dateInput.hoveredlineHeight || dateInput.lineHeight || "normal",
          textShadow:
            dateInput.hoveredtextShadow || dateInput.textShadow || "none",
          textAlign:
            dateInput.hoveredtextAlign || dateInput.textAlign || "left",
          verticalAlign:
            dateInput.hoveredverticalAlign ||
            dateInput.verticalAlign ||
            "baseline",
          textDecoration:
            dateInput.hoveredtextDecoration ||
            dateInput.textDecoration ||
            "none",
          textTransform:
            dateInput.hoveredtextTransform || dateInput.textTransform || "none",
          letterSpacing:
            dateInput.hoveredletterSpacing ||
            dateInput.letterSpacing ||
            "normal",
          wordSpacing:
            dateInput.hoveredwordSpacing || dateInput.wordSpacing || "normal",
          textIndent:
            dateInput.hoveredtextIndent || dateInput.textIndent || "0",
          whiteSpace:
            dateInput.hoveredwhiteSpace || dateInput.whiteSpace || "normal",
          textOverflow:
            dateInput.hoveredtextOverflow || dateInput.textOverflow || "clip",
          direction: dateInput.hovereddirection || dateInput.direction || "ltr",
          unicodeBidi:
            dateInput.hoveredunicodeBidi || dateInput.unicodeBidi || "normal",
          writingMode:
            dateInput.hoveredwritingMode ||
            dateInput.writingMode ||
            "horizontal-tb",

          cursor: dateInput.hoveredcursor || dateInput.cursor || "default",
          transform:
            dateInput.hoveredtransform || dateInput.transform || "none",
          transition:
            dateInput.hoveredtransition || dateInput.transition || "none",
        }
      : {};
  const activeStyles =
    isDivActive && dateInput.pseudoClass === "active"
      ? {
          width: dateInput.activatedwidth || dateInput.width || "200px",
          height: dateInput.activatedheight || dateInput.height || "auto",

          padding: dateInput.activatedpadding || dateInput.padding || "0",
          paddingTop:
            dateInput.activatedpaddingTop || dateInput.activatedpadding || "0",
          paddingRight:
            dateInput.activatedpaddingRight ||
            dateInput.activatedpadding ||
            "0",
          paddingBottom:
            dateInput.activatedpaddingBottom ||
            dateInput.activatedpadding ||
            "0",
          paddingLeft:
            dateInput.activatedpaddingLeft || dateInput.activatedpadding || "0",
          margin: dateInput.activatedmargin || dateInput.margin || "0px",
          marginTop:
            dateInput.activatedmarginTop || dateInput.activatedmargin || "0px",
          marginRight:
            dateInput.activatedmarginRight ||
            dateInput.activatedmargin ||
            "0px",
          marginBottom:
            dateInput.activatedmarginBottom ||
            dateInput.activatedmargin ||
            "0px",
          marginLeft:
            dateInput.activatedmarginLeft ||
            dateInput.activatedmargin ||
            "10px",

          borderTop:
            dateInput.activatedborderTop ||
            dateInput.activatedborder ||
            dateInput.border ||
            "1px solid #000000",
          borderRight:
            dateInput.activatedborderRight ||
            dateInput.activatedborder ||
            dateInput.border ||
            "1px solid #000000",
          borderBottom:
            dateInput.activatedborderBottom ||
            dateInput.activatedborder ||
            dateInput.border ||
            "1px solid #000000",
          borderLeft:
            dateInput.activatedborderLeft ||
            dateInput.activatedborder ||
            dateInput.border ||
            "1px solid #000000",
          borderSapcing:
            dateInput.activatedborderSpacing ||
            dateInput.borderSpacing ||
            "0px",
          borderCollapse:
            dateInput.activatedborderCollapse ||
            dateInput.borderCollapse ||
            "0px",
          borderRadius:
            dateInput.activatedborderRadius || dateInput.borderRadius || "0",
          outline: dateInput.activatedoutline || dateInput.outline || "none",

          position:
            dateInput.activatedposition || dateInput.position || "relative",
          top: dateInput.activatedtop || dateInput.top || "auto",
          right: dateInput.activatedright || dateInput.right || "auto",
          bottom: dateInput.activatedbottom || dateInput.bottom || "auto",
          left: dateInput.activatedleft || dateInput.left || "auto",
          zIndex: dateInput.activatedzIndex || dateInput.zIndex || "auto",

          color: dateInput.activatedcolor || dateInput.color || "#000000",
          backgroundColor:
            dateInput.activatedbackgroundColor ||
            dateInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (dateInput.activatedbackgroundImage) {
              if (dateInput.activatedbackgroundImage.startsWith("./")) {
                const imageName = dateInput.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dateInput.activatedbackgroundImage})`;
            }
            if (dateInput.backgroundImage) {
              if (dateInput.backgroundImage.startsWith("./")) {
                const imageName = dateInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${dateInput.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            dateInput.activatedbackgroundPosition ||
            dateInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            dateInput.activatedbackgroundSize ||
            dateInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            dateInput.activatedbackgroundRepeat ||
            dateInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            dateInput.activatedbackgroundAttachment ||
            dateInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            dateInput.activatedboxShadow || dateInput.boxShadow || "none",
          opacity: dateInput.activatedOpacity || dateInput.opacity || 1,
          display: dateInput.activateddisplay || dateInput.display || "inline",

          fontFamily:
            dateInput.activatedfontFamily || dateInput.fontFamily || "inherit",
          fontSize:
            dateInput.activatedfontSize || dateInput.fontSize || "inherit",
          fontWeight:
            dateInput.activatedfontWeight || dateInput.fontWeight || "normal",
          fontStyle:
            dateInput.activatedfontStyle || dateInput.fontStyle || "normal",
          fontVariant:
            dateInput.activatedfontVariant || dateInput.fontVariant || "normal",
          lineHeight:
            dateInput.activatedlineHeight || dateInput.lineHeight || "normal",
          textShadow:
            dateInput.activatedtextShadow || dateInput.textShadow || "none",
          textAlign:
            dateInput.activatedtextAlign || dateInput.textAlign || "left",
          verticalAlign:
            dateInput.activatedverticalAlign ||
            dateInput.verticalAlign ||
            "baseline",
          textDecoration:
            dateInput.activatedtextDecoration ||
            dateInput.textDecoration ||
            "none",
          textTransform:
            dateInput.activatedtextTransform ||
            dateInput.textTransform ||
            "none",
          letterSpacing:
            dateInput.activatedletterSpacing ||
            dateInput.letterSpacing ||
            "normal",
          wordSpacing:
            dateInput.activatedwordSpacing || dateInput.wordSpacing || "normal",
          textIndent:
            dateInput.activatedtextIndent || dateInput.textIndent || "0",
          whiteSpace:
            dateInput.activatedwhiteSpace || dateInput.whiteSpace || "normal",
          textOverflow:
            dateInput.activatedtextOverflow || dateInput.textOverflow || "clip",
          direction:
            dateInput.activateddirection || dateInput.direction || "ltr",
          unicodeBidi:
            dateInput.activatedunicodeBidi || dateInput.unicodeBidi || "normal",
          writingMode:
            dateInput.activatedwritingMode ||
            dateInput.writingMode ||
            "horizontal-tb",

          cursor: dateInput.activatedcursor || dateInput.cursor || "default",
          transform:
            dateInput.activatedtransform || dateInput.transform || "none",
          transition:
            dateInput.activatedtransition || dateInput.transition || "none",
        }
      : {};

  const inputStyle = {
    width: dateInput.width || "200px",
    height: dateInput.height || "auto",

    margin: dateInput.margin || "0px",
    marginTop: dateInput.marginTop || dateInput.margin || "0",
    marginRight: dateInput.marginRight || dateInput.margin || "0px",
    marginBottom: dateInput.marginBottom || dateInput.margin || "0",
    marginLeft: dateInput.marginLeft || dateInput.margin || "10px",
    padding: dateInput.padding || "0px",
    paddingTop: dateInput.paddingTop || dateInput.padding || "0",
    paddingRight: dateInput.paddingRight || dateInput.padding || "0",
    paddingBottom: dateInput.paddingBottom || dateInput.padding || "0",
    paddingLeft: dateInput.paddingLeft || dateInput.padding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : dateInput.borderTop || dateInput.border || "1px solid #000000",
    borderRight: isHovered
      ? "1px dashed #555"
      : dateInput.borderRight || dateInput.border || "1px solid #000000",
    borderBottom: isHovered
      ? "1px dashed #555"
      : dateInput.borderBottom || dateInput.border || "1px solid #000000",
    borderLeft: isHovered
      ? "1px dashed #555"
      : dateInput.borderLeft || dateInput.border || "1px solid #000000",

    borderSapcing: dateInput.borderSpacing || "0px",
    borderCollapse: dateInput.borderCollapse || "0px",
    borderRadius: dateInput.borderRadius || "0",
    outline: dateInput.outline || "none",

    position: dateInput.position || "static",
    top: dateInput.top || "auto",
    right: dateInput.right || "auto",
    bottom: dateInput.bottom || "auto",
    left: dateInput.left || "auto",
    zIndex: dateInput.zIndex || "auto",

    color: dateInput.color || "#000000",
    backgroundColor: dateInput.backgroundColor || "#ffffff",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundPosition:
      dateInput.focusedbackgroundPosition ||
      dateInput.backgroundPosition ||
      "0% 0%",
    backgroundSize:
      dateInput.focusedbackgroundSize || dateInput.backgroundSize || "auto",
    backgroundRepeat:
      dateInput.focusedbackgroundRepeat ||
      dateInput.backgroundRepeat ||
      "repeat",
    backgroundAttachment:
      dateInput.focusedbackgroundAttachment ||
      dateInput.backgroundAttachment ||
      "scroll",

    fontSize: dateInput.fontSize || "inherit",
    fontFamily: dateInput.fontFamily || "inherit",
    fontWeight: dateInput.fontWeight || "normal",
    fontStyle: dateInput.fontStyle || "normal",
    fontVariant: dateInput.fontVariant || "normal",
    lineHeight: dateInput.lineHeight || "normal",
    textAlign: dateInput.textAlign || "left",
    textDecoration: dateInput.textDecoration || "none",
    textTransform: dateInput.textTransform || "none",
    textShadow: dateInput.textShadow || "none",
    verticalAlign: dateInput.verticalAlign || "baseline",
    letterSpacing: dateInput.letterSpacing || "normal",
    wordSpacing: dateInput.wordSpacing || "normal",
    textIndent: dateInput.textIndent || "0",
    whiteSpace: dateInput.whiteSpace || "normal",
    textOverflow: dateInput.textOverflow || "clip",
    direction: dateInput.direction || "ltr",
    unicodeBidi: dateInput.unicodeBidi || "normal",
    writingMode: dateInput.writingMode || "horizontal-tb",

    opacity: dateInput.opacity || "1",
    display: dateInput.display || "inline",
    cursor: dateInput.cursor || "auto",

    transform: dateInput.transform || "none",
    transition: dateInput.transition || "none",

    scale: isHovered ? "1.01" : "1",
    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const labelStyle = {
    margin: dateInput.labelmargin || "0px",
    marginTop: dateInput.labelmarginTop || dateInput.labelmargin || "0",
    marginRight: dateInput.labelmarginRight || dateInput.labelmargin || "0px",
    marginBottom: dateInput.labelmarginBottom || dateInput.labelmargin || "0",
    marginLeft: dateInput.labelmarginLeft || dateInput.labelmargin || "0",
    padding: dateInput.labelpadding || "0px",
    paddingTop: dateInput.labelpaddingTop || dateInput.labelpadding || "0",
    paddingRight: dateInput.labelpaddingRight || dateInput.labelpadding || "0",
    paddingBottom:
      dateInput.labelpaddingBottom || dateInput.labelpadding || "0",
    paddingLeft: dateInput.labelpaddingLeft || dateInput.labelpadding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : dateInput.labelborderTop || dateInput.labelborder || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : dateInput.labelborderRight || dateInput.labelborder || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : dateInput.labelborderBottom || dateInput.labelborder || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : dateInput.labelborderLeft || dateInput.labelborder || "none",

    borderSapcing: dateInput.labelborderSpacing || "0px",
    borderCollapse: dateInput.labelborderCollapse || "0px",
    borderRadius: dateInput.labelborderRadius || "0",
    outline: dateInput.labeloutline || "none",

    position: dateInput.labelposition || "static",
    top: dateInput.labeltop || "auto",
    right: dateInput.labelright || "auto",
    bottom: dateInput.labelbottom || "auto",
    left: dateInput.labelleft || "auto",
    zIndex: dateInput.labelzIndex || "auto",

    color: dateInput.labelcolor || "#000000",
    backgroundColor: dateInput.labelbackgroundColor || "#ffffff",
    backgroundImage: backgroundImagelabelUrl
      ? `url(${backgroundImagelabelUrl})`
      : labelconstructGradientString(),
    backgroundPosition:
      dateInput.labelbackgroundPosition ||
      dateInput.labelbackgroundPosition ||
      "0% 0%",
    backgroundSize:
      dateInput.labelbackgroundSize || dateInput.labelbackgroundSize || "auto",
    backgroundRepeat:
      dateInput.labelbackgroundRepeat ||
      dateInput.labelbackgroundRepeat ||
      "repeat",
    backgroundAttachment:
      dateInput.labelbackgroundAttachment ||
      dateInput.labelbackgroundAttachment ||
      "scroll",

    fontSize: dateInput.labelfontSize || "inherit",
    fontFamily: dateInput.labelfontFamily || "inherit",
    fontWeight: dateInput.labelfontWeight || "normal",
    fontStyle: dateInput.labelfontStyle || "normal",
    fontVariant: dateInput.labelfontVariant || "normal",
    lineHeight: dateInput.labellineHeight || "normal",
    textAlign: dateInput.labeltextAlign || "left",
    textDecoration: dateInput.labeltextDecoration || "none",
    textTransform: dateInput.labeltextTransform || "none",
    textShadow: dateInput.labeltextShadow || "none",
    verticalAlign: dateInput.labelverticalAlign || "baseline",
    letterSpacing: dateInput.labelletterSpacing || "normal",
    wordSpacing: dateInput.labelwordSpacing || "normal",
    textIndent: dateInput.labeltextIndent || "0",
    whiteSpace: dateInput.labelwhiteSpace || "normal",
    textOverflow: dateInput.labeltextOverflow || "clip",
    direction: dateInput.labeldirection || "ltr",
    unicodeBidi: dateInput.labelunicodeBidi || "normal",
    writingMode: dateInput.labelwritingMode || "horizontal-tb",

    opacity: dateInput.labelopacity || "1",
    display: dateInput.display || "inline",
    cursor: dateInput.cursor || "auto",

    transform: dateInput.transform || "none",
    transition: dateInput.transition || "none",
  };

  return (
    <>
      <label style={labelStyle}>{dateInput.label || "Date"}</label>
      <input
        style={inputStyle}
        pattern={dateInput.pattern}
        type="date"
        onMouseEnter={() => setIsDivHovered(true)}
        onMouseLeave={() => setIsDivHovered(false)}
        onFocus={() => setIsDivFocused(true)}
        onBlur={() => setIsDivFocused(false)}
        onMouseDown={() => setIsDivActive(true)}
        onMouseUp={() => setIsDivActive(false)}
      />
    </>
  );
};

export default DateInputComponent;
